import { PropsWithChildren } from "react"
import { assertUnreachable } from "../../../../../utils/types"
import { SectionHeader } from "./SectionHeader"
import { Product } from "../../acquisitionForm/form/useAcquisitionFormSchema"
import { useAcquisitionProgress } from "../AcquisitionProgressContext"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { theme } from "../../../../../styles/stitches.config"
import Separator from "../../../../../components/Separator"

function getHouseholdSubheader(product: Product) {
  switch (product) {
    case "consumption":
      return "Jsem domácnost a chci elektřinu odebírat"
    case "production":
      return "Jsem domácnost a chci elektřinu prodávat"
    case "productionAndConsumption":
      return "Jsem domácnost a chci elektřinu odebírat i prodávat"
    default:
      return assertUnreachable(product)
  }
}

function getBusinessSubheader(product: Product) {
  switch (product) {
    case "consumption":
      return "Jsem firma a chci elektřinu odebírat"
    case "production":
      return "Jsem firma a chci elektřinu prodávat"
    case "productionAndConsumption":
      return "Jsem firma a chci elektřinu odebírat i prodávat"
    default:
      return assertUnreachable(product)
  }
}

export function FormHeader(props: PropsWithChildren) {
  const progress = useAcquisitionProgress()
  if (!progress.customerType || !progress.product) {
    return null
  }

  const subheader =
    progress.customerType === "business"
      ? getBusinessSubheader(progress.product)
      : getHouseholdSubheader(progress.product)

  return (
    <>
      <SectionHeader stepsNum={progress.currentStep} maxSteps={progress.totalSteps} subHeading={subheader}>
        {props.children}
      </SectionHeader>
      <Spacer size={theme.space.s6} />
      <Separator orientation="horizontal" />
      <Spacer size={theme.space.s6} />
    </>
  )
}
